import { TypeDefinition } from "../models/generic";

export class ErrorCodes {
    public static NoError: TypeDefinition = { id: 0, name: "No error" };
    public static Error: TypeDefinition = { id: 1, name: "Error" };
    public static ValidationError: TypeDefinition = { id: 2, name: "Validation error" };

    public static NotFound: TypeDefinition = { id: 101, name: "Not found" };
    public static AccessDenied: TypeDefinition = { id: 102, name: "Access denied" };

    public static Files_NotFound: TypeDefinition = { id: 201, name: "File not found" };

    public static Users_NotFound: TypeDefinition = { id: 301, name: "User not found" };
    public static Users_LoginFailed: TypeDefinition = { id: 302, name: "User login failed" };
    public static Users_PasswordResetExpired: TypeDefinition = { id: 303, name: "User password reset expired" };
    public static Users_UsernameExists: TypeDefinition = { id: 304, name: "Username already exists" };
    public static Users_InactiveUserExists: TypeDefinition = { id: 305, name: "Inactive user exists" };
    public static Users_NotAMember: TypeDefinition = { id: 306, name: "User is not a member" };

    public static Nav_UrlAlreadyExists: TypeDefinition = { id: 401, name: "Nav URL already exists" };
    public static Nav_ItemHasChildren: TypeDefinition = { id: 402, name: "Nav item has children" };
    public static Nav_ItemIsLocked: TypeDefinition = { id: 403, name: "Nav item is locked" };

    public static Members_NotFound: TypeDefinition = { id: 701, name: "Member not found" };
    public static Members_NotActive: TypeDefinition = { id: 702, name: "Member not active" };

    public static Event_NotFound: TypeDefinition = { id: 801, name: "Event not found" };
    public static Event_RsvpNotEnabled: TypeDefinition = { id: 802, name: "Event RSVP is not enabled" };
    public static Event_DirectRsvpNotAllowed: TypeDefinition = { id: 803, name: "Event Direct RSVP is not allowed" };
    public static Event_TableRsvpNotAllowed: TypeDefinition = { id: 804, name: "Event Table RSVP is not allowedd" };
    public static Event_RsvpExpired: TypeDefinition = { id: 805, name: "Event RSVP expired" };
    public static Event_GuestRsvpNotAllowed: TypeDefinition = { id: 806, name: "Event guest RSVP is not allowed" };
    public static Event_ConflictingRsvp: TypeDefinition = { id: 807, name: "Event conflicting RSVP" };
    public static Event_SlotsFilled: TypeDefinition = { id: 808, name: "Event RSVP slots filled" };
    public static Event_DirectRsvpNotEnabled: TypeDefinition = { id: 809, name: "Event Direct RSVP is not enabled" };
    public static Event_TableRsvpNotEnabled: TypeDefinition = { id: 810, name: "Event Table RSVP is not enabled" };

    public static Abstracts_NotFound: TypeDefinition = { id: 901, name: "Abstract not found" };
    public static Abstracts_GradingNoAccess: TypeDefinition = { id: 951, name: "Abstract grading access denied" };
    public static Abstracts_GradingCategoryNotFound: TypeDefinition = { id: 952, name: "Abstract grading category not found" };
    public static Abstracts_GradingPlacementNotFound: TypeDefinition = { id: 953, name: "Abstract grading placement not found" };
    public static Abstracts_GroupHasChildren: TypeDefinition = { id: 961, name: "Abstract group has children" };
    public static Abstracts_UserNotReviewer: TypeDefinition = { id: 971, name: "Abstract user is not reviewer" };
    public static Abstracts_ReviewerNotFound: TypeDefinition = { id: 972, name: "Abstract reviewer not found" };
    public static Abstracts_SpeakerAttestation: TypeDefinition = { id: 973, name: "Speaker attestation for abstract is required" };

    public static CareerCenter_RefMemberRequired: TypeDefinition = { id: 1001, name: "Active member reference required" };

    public static Values: TypeDefinition[] = [
        ErrorCodes.NoError,
        ErrorCodes.Error,
        ErrorCodes.ValidationError,
        ErrorCodes.NotFound,
        ErrorCodes.AccessDenied,
        ErrorCodes.Files_NotFound,

        ErrorCodes.Users_NotFound,
        ErrorCodes.Users_LoginFailed,
        ErrorCodes.Users_PasswordResetExpired,
        ErrorCodes.Users_UsernameExists,
        ErrorCodes.Users_InactiveUserExists,
        ErrorCodes.Users_NotAMember,

        ErrorCodes.Nav_UrlAlreadyExists,
        ErrorCodes.Nav_ItemHasChildren,
        ErrorCodes.Nav_ItemIsLocked,

        ErrorCodes.Members_NotFound,
        ErrorCodes.Members_NotActive,

        ErrorCodes.Event_NotFound,
        ErrorCodes.Event_RsvpNotEnabled,
        ErrorCodes.Event_DirectRsvpNotAllowed,
        ErrorCodes.Event_TableRsvpNotAllowed,
        ErrorCodes.Event_RsvpExpired,
        ErrorCodes.Event_GuestRsvpNotAllowed,
        ErrorCodes.Event_ConflictingRsvp,
        ErrorCodes.Event_SlotsFilled,
        ErrorCodes.Event_DirectRsvpNotEnabled,
        ErrorCodes.Event_TableRsvpNotEnabled,

        ErrorCodes.Abstracts_NotFound,
        ErrorCodes.Abstracts_GradingNoAccess,
        ErrorCodes.Abstracts_GradingCategoryNotFound,
        ErrorCodes.Abstracts_GradingPlacementNotFound,
        ErrorCodes.Abstracts_GroupHasChildren,
        ErrorCodes.Abstracts_UserNotReviewer,
        ErrorCodes.Abstracts_ReviewerNotFound,
        ErrorCodes.Abstracts_SpeakerAttestation,

        ErrorCodes.CareerCenter_RefMemberRequired,
    ];
}



// WEBPACK FOOTER //
// ./src/domain/ErrorCodes.ts